import type { ReactNode } from 'react';

export const symbol_table_convert: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M440-120v-500H120v-160q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H440Zm60-60h280v-190H500v190Zm0-250h280v-190H500v190ZM180-680h600v-100H180v100Zm115 200q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5-50 0-85 34.91T175-300q0 46 30 80t75 39v-89q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v160q0 12.75-8.62 21.37Q322.75-80 310-80H150q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h64q-45-22-72-64.5T115-300q0-74.84 52.58-127.42T295-480Z"
		/>
	</svg>
);
